import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import Services from "@/components/Services";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ClickSpark from "@/components/ClickSpark";
import { Toaster } from "@/components/ui/sonner";
import DailyGrind from "@/components/demos/DailyGrind";
import IronIvory from "@/components/demos/IronIvory";
import SummitRoofing from "@/components/demos/SummitRoofing";
import AtlasMoving from "@/components/demos/AtlasMoving";
import GreenLine from "@/components/demos/GreenLine";
import ThresholdStudio from "@/components/demos/ThresholdStudio";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const Home = () => {
  return (
    <ClickSpark sparkColor="#FE4A90" sparkSize={10} sparkRadius={15} sparkCount={8} duration={400}>
      <div data-testid="home-page" className="min-h-screen bg-[#FFFDF5]">
        <header>
          <Navbar />
        </header>
        <main>
          <Hero />
          <MarqueeStrip />
          <Portfolio />
          <About />
          <Services />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </ClickSpark>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ClickSpark sparkColor="#FE4A90" sparkSize={10} sparkRadius={15} sparkCount={8} duration={400}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work/the-daily-grind" element={<DailyGrind />} />
          <Route path="/work/iron-ivory" element={<IronIvory />} />
          <Route path="/work/summit-roofing" element={<SummitRoofing />} />
          <Route path="/work/atlas-moving" element={<AtlasMoving />} />
          <Route path="/work/greenline" element={<GreenLine />} />
          <Route path="/work/threshold-studio" element={<ThresholdStudio />} />
        </Routes>
      </ClickSpark>
    </BrowserRouter>
  );
}

export default App;
